import { forwardRef } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import type {
  TComboboxContentElement,
  TComboboxContentProps,
} from "@/ui/components/form/Combobox/Combobox.config";
import { cn } from "@/ui/lib/utils";

export const ComboboxContent = forwardRef<TComboboxContentElement, TComboboxContentProps>(
  (
    {
      align = "start",
      className,
      portalContainer,
      sideOffset = 4,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal container={portalContainer}>
      <PopoverPrimitive.Content
        data-component="ComboboxContent"
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "relative z-50 min-w-[var(--radix-popover-trigger-width)] overflow-hidden rounded-sys-sm border border-solid border-component-input-default bg-component-input-focused shadow-md",
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);

ComboboxContent.displayName = PopoverPrimitive.Content.displayName;
